export default {
  BEACON: {
    BEACON: "Beacon List",
    BEACON1: "Beacon Name",
    BEACON2: "Enter Beacon Name",
    HEADER: "Register Beacon",
    DETAILS: "Beacon Details",
  },
};
